import { ViewIds } from '@ardoq/api-types';
import { KnowledgeBaseLink } from '@ardoq/knowledge-base';
import { onViewSettingsUpdate } from 'tabview/onViewSettingsUpdate';
import { viewHasLegend } from 'views/metaInfoTabs';
import { getRightMenuConfig } from 'viewSettings/getRightMenuConfig';
import { SettingsBar } from '@ardoq/settings-bar';
import type { ExportConfigParams } from '@ardoq/view-settings';
import { componentMatrixLeftMenu } from './leftMenu';
import {
  ComponentMatrixViewSettings,
  ComponentMatrixViewSettingsState,
} from './types';
import type { I18nLocale } from '@ardoq/i18n';
import type { Locale } from '@ardoq/locale';

const VIEW_ID = ViewIds.COMPONENT_MATRIX;

type ComponentMatrixSettingsBarProps = {
  viewSettings: ComponentMatrixViewSettings;
  exports: ExportConfigParams;
  viewSettingsState: ComponentMatrixViewSettingsState;
  locale: Locale;
  i18nLocale: I18nLocale;
};
const ComponentMatrixSettingsBar = ({
  viewSettings,
  exports,
  viewSettingsState,
  locale,
  i18nLocale,
}: ComponentMatrixSettingsBarProps) => (
  <div className="menuContainer">
    <SettingsBar
      viewId={VIEW_ID}
      i18nLocale={i18nLocale}
      leftMenu={componentMatrixLeftMenu(
        viewSettings,
        viewSettingsState,
        locale,
        i18nLocale
      )}
      rightMenu={getRightMenuConfig({
        isViewpointMode: false,
        viewId: VIEW_ID,
        viewstate: viewSettings,
        exports,
        withLegend: viewHasLegend(VIEW_ID),
        knowledgeBaseLink: KnowledgeBaseLink.COMPONENT_MATRIX,
        onViewSettingsUpdate,
        i18nLocale,
      })}
    />
  </div>
);

export { ComponentMatrixSettingsBar };
